import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1225e9fe")

_pushScopeId("data-v-1225e9fe")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createVNode("a", { href: "https://apps.apple.com/at/app/boostpack/id1620312288?l=en" }, [
  /*#__PURE__*/_createVNode("img", {
    alt: "",
    class: "object-cover rounded-3xl",
    src: "/img/test/testAd.webp"
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.isFullCookieConsentAllowed())
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (_ctx.isDevelopment() === true)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _hoisted_3
            ]))
          : (_openBlock(), _createBlock("ins", {
              key: 1,
              "data-ad-client": _ctx.adClient,
              id: _ctx.adId,
              style: _ctx.adStyle,
              "data-adtest": _ctx.isDevelopment() === true ? 'on' : 'off',
              "data-ad-layout-key": _ctx.adLayoutKey,
              "data-ad-slot": _ctx.adSlot,
              "data-ad-format": _ctx.adFormat,
              "data-full-width-responsive": _ctx.adResponsive
            }, null, 12, ["data-ad-client", "id", "data-adtest", "data-ad-layout-key", "data-ad-slot", "data-ad-format", "data-full-width-responsive"]))
      ]))
    : _createCommentVNode("", true)
})